import { render, staticRenderFns } from "./archcont.vue?vue&type=template&id=9162c09c&scoped=true&"
import script from "./archcont.vue?vue&type=script&lang=js&"
export * from "./archcont.vue?vue&type=script&lang=js&"
import style0 from "./archcont.vue?vue&type=style&index=0&id=9162c09c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9162c09c",
  null
  
)

export default component.exports